















































































import { Component, Vue, Model } from "vue-property-decorator";

import {
  PlanningControlSettings,
  ObjectiveFunctionParameters,
  OccupiedTimeUsage,
} from "@/data/models/SchedulingSettings";

import PickerDialogComponent from "@/components/common/PickerDialog.vue";
import TimePickerComponent from "@/components/common/TimePicker.vue";
import ColorPickerDialogComponent from "@/components/common/ColorPickerDialog.vue";

import {
  TaskType,
  localiseTaskType,
  getTaskTypeFieldName,
} from "@/data/models/Task";
import ObjectiveFunctionParametersComponent from "./ObjectiveFunctionParameters.vue";

@Component({
  components: {
    "time-picker": TimePickerComponent,
    "color-picker": ColorPickerDialogComponent,
    "objective-function-parameters": ObjectiveFunctionParametersComponent,
    picker: PickerDialogComponent,
  },
})
export default class PlanningControlSettingsComponent extends Vue {
  @Model("change")
  planningControlSettings!: PlanningControlSettings;

  get objectiveFunctionParameters() {
    return this.planningControlSettings.objectiveFunctionParameters;
  }

  set objectiveFunctionParameters(
    objectiveFunctionParameters: ObjectiveFunctionParameters
  ) {
    this.updatePlanningControlSettings((planningControlSettings) => {
      planningControlSettings.objectiveFunctionParameters = objectiveFunctionParameters;
    });
  }

  occupiedTimeUsageOptions = [
    OccupiedTimeUsage.NONE,
    OccupiedTimeUsage.SHOW,
    OccupiedTimeUsage.PLAN,
  ];

  taskTypes = [
    TaskType.LEAK_DETECTION,
    TaskType.DAMAGE_ASSESSMENT,
    TaskType.DRYING_SETUP,
    TaskType.INTERMEDIATE_MEASUREMENT,
    TaskType.DRYING_CONCLUSION,
    TaskType.REPAIR,
  ];

  groupedTaskTypes = this.calculateGroupedLabels(this.taskTypes);

  calculateGroupedLabels(taskTypes: TaskType[]) {
    const groupSize = 4;
    const result: TaskType[][] = [];

    for (let i = 0; i < taskTypes.length; i += groupSize) {
      result.push(taskTypes.slice(i, i + groupSize));
    }

    return result;
  }

  set travelTimeUsage(occupiedTimeUsage: OccupiedTimeUsage) {
    this.updatePlanningControlSettings(
      (planningControlSettings) =>
        (planningControlSettings.travelTimeUsage = occupiedTimeUsage)
    );
  }

  get travelTimeUsage() {
    return this.planningControlSettings.travelTimeUsage;
  }

  set breakUsage(occupiedTimeUsage: OccupiedTimeUsage) {
    this.updatePlanningControlSettings(
      (planningControlSettings) =>
        (planningControlSettings.breakUsage = occupiedTimeUsage)
    );
  }

  get breakUsage() {
    return this.planningControlSettings.breakUsage;
  }

  get acceptableDelayInMin() {
    return this.planningControlSettings.acceptableDelayInMin;
  }

  set acceptableDelayInMin(acceptableDelayInMin: number) {
    this.updatePlanningControlSettings(
      (planningControlSettings) =>
        (planningControlSettings.acceptableDelayInMin = acceptableDelayInMin)
    );
  }

  getDefaultTaskDurationValue(taskType: TaskType) {
    return this.planningControlSettings.defaultTaskDurations[
      getTaskTypeFieldName(taskType)
    ];
  }

  setDefaultTaskDurationValue(taskType: TaskType, input: string) {
    const inputValue = Number(input);

    if (isNaN(inputValue)) {
      return false;
    }

    this.updatePlanningControlSettings(
      (planningControlSettings) =>
        (planningControlSettings.defaultTaskDurations[
          getTaskTypeFieldName(taskType)
        ] = inputValue)
    );
  }

  updatePlanningControlSettings(
    callback: (planningControlSettings: PlanningControlSettings) => void
  ) {
    const currentValue = this.planningControlSettings;
    callback(currentValue);

    const update = {
      ...currentValue,
    };

    this.$emit("change", update);
  }

  localiseTaskType(taskType: TaskType) {
    return localiseTaskType(this, taskType);
  }

  localiseOccupiedTimeUsage(occupiedTimeUsage: OccupiedTimeUsage) {
    switch (occupiedTimeUsage) {
      case OccupiedTimeUsage.NONE:
        return this.$t("settings.scheduling.occupiedTimeUsage.none");
      case OccupiedTimeUsage.SHOW:
        return this.$t("settings.scheduling.occupiedTimeUsage.show");
      case OccupiedTimeUsage.PLAN:
        return this.$t("settings.scheduling.occupiedTimeUsage.plan");
    }
  }
}
